/**
 * @deprecated
 */
export enum CRUDServiceType {
  admin = 'admin',
  public = 'public',
}
